import React from 'react';
import Page from '../core/screens/Page';
import Grid from '../responsive/Grid';
import Button from '../ui/Button';
import { ArrowRight, ArrowDown, MissionLogo } from '../ui/Vectors';

import '../css/screens/MissionPage.scss';

export default class MissionPage extends Page
{
	render() {
		return this.wrap(
			<React.Fragment>
				<Grid cols={1} className='text-center logo'>
					<MissionLogo></MissionLogo>
				</Grid>
				<Grid cols={2} breakpoints={{small: {cols: 4}}} className="padding">
					<div className='tag'>{this.props.content.tag}</div>
					<div className='title'>{this.props.content.title}</div>
					<div className='text'>{this.props.content.text}</div>
				</Grid>
				<Grid cols={4} className='text-center logo-mobile'>
					<MissionLogo></MissionLogo>
				</Grid>
			</React.Fragment>
		);
	}
}

function Roadmap(props:{data, isFirst})
{
	let classes = ['roadmapItem'];
	if(props.data.className) classes.push(props.data.className)
	return (
		<div className={classes.join(' ')}>
			{
				(!props.isFirst)?(
					<Grid cols={4}>
						<Grid cols={1} className="text-center">
							<ArrowDown></ArrowDown>
						</Grid>
					</Grid>
				):null
			}
			<div className="flex-middle">
				<Grid cols={1}>
					<div className='title'>{props.data.title}</div>
					<div className='status'>{props.data.status}</div>
				</Grid>
				<Grid cols={2} breakpoints={{small: {cols: 3, skip: 0}}} className='padding'>
					<div className='text padding'>
						{props.data.date + '\n\n'}
						<ul>
							{props.data.items.map((e, i)=>
							{
								return (<li key={i + '_roadmap'}>{e}</li>);
							})}
						</ul>
					</div>
				</Grid>
			</div>
		</div>
	)
}